// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3AdsP","content":"GlobalSearch_content__21xQ0"};